import React, {Component} from 'react';
import Header from '../Componentes/header'
import Footer from '../Componentes/footer'
import {Form, Row, Col } from 'reactstrap'

export default class PaginaNoEncontrada extends Component {

    render() {
        return (
            <html>
                <Header />
                <div className="container">
                    <div className="login-page">
                        <div className="form">
                            <Form className="login-form" method="post" encType="multipart/form-data">
                                <div className="container my-5">
                                    <Row>
                                        <Col className="col-12 align-self-center">
                                            <h1>404</h1>
                                            <p>Pagina No encontrada</p>
                                        </Col>
                                    </Row>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
                <Footer />
            </html>
        )
    }
}